import { ProductsResponse } from "../../../models/api/sift/back/api-products";
import { ApiBaseBack } from "../../back/api-base-back";

export class ApiGetProducts extends ApiBaseBack<ProductsResponse> {
  constructor(param: {
    serviceId: string,
    keyword?: string,
    printProcessId?: string,
  }) {
    super(
      'POST',
      '/api/v1/keywordSearchProducts',
      'JSON',
      param,
    );
  }
}
